import { render, staticRenderFns } from "./InspectionDraftEmpty.vue?vue&type=template&id=1d68e5cb&"
import script from "./InspectionDraftEmpty.vue?vue&type=script&lang=ts&"
export * from "./InspectionDraftEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports